import { Directive, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive()
@Injectable({
  providedIn: 'root',
})
export class MasterDataService extends BehaviorSubject<any> {
  // Local Arrays
  dataIncludeJobCode: any = [];
  dataJobCode: any = [];
  dataJobStatus: any = [];
  dataJobCategory: any = [];
  dataActivityType: any = [];
  dataSubManagementUnit: any = [];
  dataSubServiceLine: any = [];
  dataServiceLine: any = [];
  dataManagementUnit: any = [];
  dataOperatingUnit: any = [];
  dataBusinessUnit: any = [];
  dataJobCostCenter: any = [];
  dataResCostCenter: any = [];
  dataDepartment: any = [];
  dataCompetency: any = [];
  dataEconomicLocation: any = [];
  dataCompanyCode: any = [];
  dataLegalEntity: any = [];
  dataManageCountry: any = [];
  dataSubArea: any = [];
  dataReport:any = [];


  constructor() {
    super(null);
  }

  
  setControlsData = (data) => {
    if (data.SubAreaList != null) {
      this.dataSubArea = this.getDummyArray(data.SubAreaList);
    }
    
    if (data.ManageCountryList != null) {
      this.dataManageCountry = this.getDummyArray(data.ManageCountryList);
    }

    if (data.LegalEntityList != null) {
      this.dataLegalEntity = this.getDummyArray(data.LegalEntityList);
    }

    if (data.CompanyCodeList != null) {
      this.dataCompanyCode = this.getDummyArray(data.CompanyCodeList);
    }

    if (data.EconomicLocationList != null) {
      this.dataEconomicLocation = this.getDummyArray(data.EconomicLocationList);
    }

    if (data.CompetencyList != null) {
      this.dataCompetency = this.getDummyArray(data.CompetencyList);
    }

    if (data.DepartmentList != null) {
      this.dataDepartment = this.getDummyArray(data.DepartmentList);
    }

    if (data.ResCostCenterList != null) {
      this.dataResCostCenter = this.getDummyArray(data.ResCostCenterList);
    }

    if (data.JobCostCenterList != null) {
      this.dataJobCostCenter = this.getDummyArray(data.JobCostCenterList);
    }

    if (data.BusinessUnitList != null) {
      this.dataBusinessUnit = this.getDummyArray(data.BusinessUnitList);
    }

    if (data.OperatingUnitList != null) {
      this.dataOperatingUnit = this.getDummyArray(data.OperatingUnitList);
    }

    if (data.ManagementUnitList != null) {
      this.dataManagementUnit = this.getDummyArray(data.ManagementUnitList);
    }

    if (data.ServiceLineList != null) {
      this.dataServiceLine = this.getDummyArray(data.ServiceLineList);
    }

    if (data.SubServiceLineList != null) {
      this.dataSubServiceLine = this.getDummyArray(data.SubServiceLineList);
    }

    if (data.SubManagementUnitList != null) {
      this.dataSubManagementUnit = this.getDummyArray(
        data.SubManagementUnitList
      );
    }

    if (data.ActivityType != null) {
      this.dataActivityType = this.getDummyArray(data.ActivityType);
    }

    if (data.JobCategory != null) {
      this.dataJobCategory = this.getDummyArray(data.JobCategory);
    }

    if (data.JobStatus != null) {
      this.dataJobStatus = this.getDummyArray(data.JobStatus);
    }

    if (data.JobCode != null) {
      this.dataJobCode = this.getDummyArray(data.JobCode);
    }

    if (data.IncludeJobCode != null) {
      this.dataIncludeJobCode = this.getDummyArray(data.IncludeJobCode);
    }

    if(data.ReportList != null){
      this.dataReport = this.getDummyArray(data.ReportList);
      console.log(this.dataReport);
    }
  };

  getDummyArray = (arrayList) => {
    if (!arrayList || arrayList.length <= 0) {
      return [];
    }
    return arrayList.map((element) => {
      return {
        Id: element.ID,
        Text: element.Text,
      };
    });
  };
}
